import { getMediaTypeFromMimeType } from '@atlaskit/media-common/mediaTypeUtils';
export var getMediaTypeFromUploadableFile = function getMediaTypeFromUploadableFile(file) {
  if (file.content instanceof Blob) {
    var type = file.content.type;
    return getMediaTypeFromMimeType(type);
  } else {
    return 'unknown';
  }
};